import { Roles } from '@App/store/role'

export enum Fields {
  FORM = 'user_form',
  FIRSTNAME = 'first_name',
  LASTNAME = 'last_name',
  EMAIL = 'email',
  ORGANISATION = 'organization',
  TEAM = 'team',
  ADMIN = 'droit_acces',
  NETWORKS = 'networks',
}

export const defaultRoleSegments = {
  [Roles.SUPER_ADMIN]: [],
  [Roles.ORGANIZATION_ADMIN]: [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
  ],
  [Roles.NETWORK_ADMIN]: [1, 2, 4, 6, 8, 9, 11],
  [Roles.USER]: [16],
}
